import { render, staticRenderFns } from "./StatisticsTrialsDynamic.vue?vue&type=template&id=038b638a&scoped=true&"
import script from "./StatisticsTrialsDynamic.vue?vue&type=script&lang=js&"
export * from "./StatisticsTrialsDynamic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038b638a",
  null
  
)

export default component.exports